"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

exports.Container = function (_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: 'clp-container'
  }, children);
};